import type { TFunction } from 'i18next';
import type { EuropeUsaImportErrorDto } from '@/api/types';

/**
 * Texto de un error por fila en el idioma activo: si el backend manda `code` y existe
 * `admin.bulkUsers.errorCode.<code>` se usa la traducción; si no, el `message` (español) del backend.
 */
export function localizeRowError(error: EuropeUsaImportErrorDto, t: TFunction): string {
  if (!error.code) return error.message;
  return t(`admin.bulkUsers.errorCode.${error.code}`, { defaultValue: error.message });
}

function csvField(value: string | number): string {
  const text = String(value ?? '');
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * CSV de errores generado en el cliente (mismo formato que `errorsCsv` del backend: `linea,columna,error`,
 * separador `\n`, comillas dobles escapadas) pero con el texto localizado. El BOM lo antepone quien descarga.
 */
export function buildLocalizedErrorsCsv(errors: EuropeUsaImportErrorDto[], t: TFunction): string {
  const lines = ['linea,columna,error'];
  for (const error of errors) {
    lines.push([error.lineNumber, error.column, localizeRowError(error, t)].map(csvField).join(','));
  }
  return lines.join('\n');
}
